import React from 'react'
import './CustomersRow.scss'
import {graphql, useStaticQuery} from 'gatsby'
import {get} from 'lodash'
import PropTypes from 'prop-types'
import {GatsbyImage} from 'gatsby-plugin-image'
import PageComponent from './PageComponent'
import Carousel from '../Layout/Carousel/Carousel'
import ReactMarkdown from 'react-markdown'

const CustomersRow = ({title, customerIds, backgroundColor, grayscale}) => {
    const data = useStaticQuery(graphql`
        {
            allStrapiCustomer {
                edges {
                    node {
                        strapiId
                        logo {
                            image {
                                childImageSharp {
                                    gatsbyImageData(width: 300, placeholder: NONE, layout: CONSTRAINED)
                                }
                            }
                            alt
                        }
                    }
                }
            }
        }
    `)

    const customersWithLogo = customerIds.map((item) => {
        const customer = data.allStrapiCustomer.edges.find((customer) => customer.node.strapiId === item.id)

        return {
            id: item.id,
            logoImageData: get(customer, 'node.logo.image.childImageSharp.gatsbyImageData', null),
            logoImageAlt: get(customer, 'node.logo.alt', null),
        }
    })

    return (
        <PageComponent backgroundColor={backgroundColor} containerStyle={{overflow: 'hidden'}}>
            {!!title && (
                <div className={'page__customers-row-title'}>
                    <ReactMarkdown source={title} />
                </div>
            )}
            <Carousel>
                {customersWithLogo.map((customer) => (
                    <GatsbyImage
                        image={customer.logoImageData}
                        key={customer.id}
                        alt={customer.logoImageAlt}
                        style={{
                            filter: grayscale ? 'grayscale(100%)' : undefined,
                        }}
                    />
                ))}
            </Carousel>
        </PageComponent>
    )
}

export default CustomersRow

CustomersRow.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    customerIds: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
        })
    ),
    backgroundColor: PropTypes.string,
    grayscale: PropTypes.bool,
}

CustomersRow.defaultProps = {
    customerIds: [],
    backgroundColor: 'white',
    grayscale: false,
}
